<div class="wrapper">
  <div class="top-bar">
    <div class="d-flex">
      <span (click)="navigateToLadingPage()">
        <img src="assets/images/icon/refresh.svg" /> {{ languageData.start }}
      </span>
    </div>
    <div>
      <div>
        <img
          src="assets/images/ecolab-logo-white-app-header.png"
          alt="EcoLab Logo"
          class="logo h-30"
        />
      </div>
    </div>
    <select
      id="languageList"
      name="languageList"
      (change)="languageChange($event, '')"
      class="select-dropdown"
    >
      <option
        *ngFor="let option of languageOptions"
        [value]="option?.value"
        [selected]="option?.value === language"
      >
        {{ option?.value }}
      </option>
    </select>
  </div>

  <div class="p-3 feedback-content">
    <div class="d-flex py-2">
      <div class="ps-1 pe-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="#5eead4"
          class="mr-4 h-10 w-10 shrink-0 fill-teal-300"
        >
          <path
            d="M16.25 29.9999L5 18.7499L6.7675 16.9824L16.25 26.4637L33.2325 9.48242L35 11.2499L16.25 29.9999Z"
          ></path>
        </svg>
      </div>
      <div class="resolve-text">
        {{ languageData.resolveText }}
      </div>
    </div>

    <div>
      {{ languageData.qusetionText }}
    </div>

    <div>
      <div class="feedback-container pt-3">
        <ul>
          <li
            *ngFor="let feedback of feedbacks; let i = index"
            [class.selected]="selectedFeedbackIndex === i"
            (click)="selectFeedback(i)"
          >
            <span class="emoji" [innerHTML]="feedback.emoji"></span>
            <span *ngIf="languageIndex == 0" class="feeback-text">{{
              feedback.englishtext
            }}</span>
            <span *ngIf="languageIndex == 1" class="feeback-text">{{
              feedback.spanishtext
            }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <form>
        <div class="mb-3 mt-3">
          <!-- <label for="email" class="form-label" style="color: #52525b;">Anything else you’d like to tell us? (optional)</label> -->
          <div class="pb-1 option-text">
            {{ languageData.optionalText }}
          </div>
          <input type="text" class="form-control" />
        </div>
        <div class="d-grid feedbackSubmitBtn">
          <button
            type="button"
            class="btn btn-primary btn-block btn-lg"
            (click)="navigate('feedbackSummary')"
            [disabled]="selectedFeedbackIndex == null"
          >
            {{ languageData.submitButton }}
          </button>
        </div>
      </form>
    </div>

    <div class="pt-3">
      <div class="trainingBox">
        <p>{{ languageData.trainingMessage }}</p>
        <div class="d-flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="#006bd3"
            aria-hidden="true"
            class="h-5 w-5 mr-2"
            width="22"
          >
            <path
              fill-rule="evenodd"
              d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <div class="ps-2 video-link" (click)="navigate('training')">
            {{ languageData.videoLink }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
